<div class="case-checkin">
    <button (click)="caseCheckin($event)">Checkind på sag</button>
</div>